<template>
  <div class="page">
    <div style="padding: 30px;">
      <van-field style="margin-top: 30px;border-radius: 30px;" v-model="idCard" input-align="center"
                 placeholder="请输入身份证号" maxlength="18" size="large"/>
      <van-button style="margin-top: 100px;width: 100%;" round color="#1989fa"
                  @click="handleConfirmPreview">绑定身份
      </van-button>
    </div>
  </div>
</template>
<script>
import mixinLoad from '@/mixin/mixin-load.js'

import {
  bindPersonnelPreview,
  bindPersonnel
} from '@/api/user.js'

export default {
  name: 'BindPersonnel',
  components: {},
  mixins: [mixinLoad],
  data() {
    return {
      show: false,
      idCard: null
    }
  },
  computed: {},
  methods: {
    handleConfirmPreview() {
      if (!this.idCard) {
        this.showErrorTip("请输入身份证号")
        return;
      }
      const loading = this.showLoading();
      bindPersonnelPreview({
        idCard: this.idCard
      }).then(({
                 data
               }) => {
        loading.clear();
        this.showBindPreview(data);
      }).catch((rep) => {
        loading.clear();
        this.show = true;
        this.showErrorTip(rep.msg || rep)
      })
    },
    showBindPreview(data) {
      const name = data.name || '未录入';
      const companyName = data.companyName || '未录入';
      this.$dialog.confirm({
        title: '请确认认证信息',
        messageAlign: 'left',
        message: `姓名：${name}\n单位：${companyName}`,
        confirmButtonText: '确定认证',
        cancelButtonText: '返回',
      }).then(() => {
        this.handleConfirmBind();
      }).catch(() => {
        this.show = true;
      });
    },
    handleConfirmBind() {
      const loading = this.showLoading();
      bindPersonnel({
        idCard: this.idCard
      }).then((rep) => {
        loading.clear();
        this.show = false;
        this.showSuccessTip(rep.msg || rep);
        this.$emit('success')
      }).catch((rep) => {
        loading.clear();
        this.show = true;
        this.showErrorTip(rep.msg || rep)
      })
    }
  }
}
</script>
